// client/src/constants/newsTypes.js
const newsTypes = {
  all: "جميع المنشورات",
  campaigns: "الحملات",
  humanCases: "الحالات إنسانية",
  achievements: "الإنجازات"
};

export default newsTypes;
